"use strict";
/**
 * @file Selector
 * @desc 选择器相关的公共组件，Select & MultiSelect 共用之
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchInput = exports.OptionPlaceholder = exports.OptionContent = exports.ClearIcon = exports.StatusIcon = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var icons_1 = require("../icons");
var utils_1 = require("../utils");
var common_1 = require("./common");
var context_1 = require("./context");
function StatusIcon(_a) {
    var active = _a.active, loading = _a.loading, searchable = _a.searchable;
    var selectClassName = common_1.useSelectPrefix();
    var iconClassName = utils_1.concat(selectClassName, 'icon');
    var icon = (function () {
        if (active && loading)
            return react_1.default.createElement(icons_1.LoadingThinIcon, { className: utils_1.concat(iconClassName, 'loading') });
        if (active && searchable)
            return react_1.default.createElement(icons_1.SearchThinIcon, null);
        return react_1.default.createElement(icons_1.DownIcon, { className: utils_1.concat(iconClassName, 'arrow') });
    })();
    return (react_1.default.createElement("div", { className: iconClassName }, icon));
}
exports.StatusIcon = StatusIcon;
/** 清除按钮 */
function ClearIcon(_a) {
    var searchActive = _a.searchActive, searchValue = _a.searchValue, setSearchValue = _a.setSearchValue, focusSearchInput = _a.focusSearchInput;
    var selectClassName = common_1.useSelectPrefix();
    var _b = context_1.useSelectCtx(), selected = _b.selected, onSelect = _b.onSelect;
    // 注意在不同状态下清除按钮清除不同的内容：
    // * search active 状态下：清除当前搜索框的输入
    // * 其他状态下：清除当前 select 选中项
    var handleClearClick = react_1.useCallback(function (e) {
        e.stopPropagation(); // 防止点击造成 select active 变更
        if (searchActive) {
            setSearchValue('');
            focusSearchInput();
        }
        else {
            onSelect([]);
        }
    }, [searchActive, setSearchValue, focusSearchInput, onSelect]);
    var clearVisible = searchActive ? !!searchValue : selected.length > 0;
    var clearClassName = utils_1.concat(selectClassName, 'clear');
    var className = classnames_1.default(clearClassName, !clearVisible && utils_1.concat(clearClassName, 'invisible'));
    return react_1.default.createElement(icons_1.CloseCircleFilledIcon, { className: className, onClick: handleClearClick });
}
exports.ClearIcon = ClearIcon;
/** 选择器中对选中项进行展示 */
function OptionContent(_a) {
    var children = _a.children, className = _a.className;
    var selectClassName = common_1.useSelectPrefix();
    var optionContentClassName = utils_1.concat(selectClassName, 'option-content');
    var title = utils_1.getText(children);
    return (react_1.default.createElement("div", { className: classnames_1.default(optionContentClassName, className), title: title }, children));
}
exports.OptionContent = OptionContent;
/** 选择器中在没有选中项时对 placeholder 进行展示 */
function OptionPlaceholder(_a) {
    var children = _a.children;
    var selectClassName = common_1.useSelectPrefix();
    var className = utils_1.concat(selectClassName, 'placeholder');
    return react_1.default.createElement(OptionContent, { className: className }, children);
}
exports.OptionPlaceholder = OptionPlaceholder;
function useSearchInput(active, extraProps) {
    var selectClassName = common_1.useSelectPrefix();
    var _a = react_1.useState(''), searchValue = _a[0], setSearchValue = _a[1];
    var handleSearchInputChange = react_1.useCallback(function (e) {
        setSearchValue(e.target.value);
    }, []);
    var searchInputRef = react_1.useRef(null);
    var focusSearchInput = react_1.useCallback(function () {
        var _a;
        (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    react_1.useEffect(function () {
        if (active) {
            // active 变更会导致 input visibility 的变更
            // 延迟一点做 focus，否则会没法正确地获得焦点
            var timer_1 = setTimeout(focusSearchInput, 100);
            return function () { return clearTimeout(timer_1); };
        }
        setSearchValue('');
    }, [active, focusSearchInput]);
    var extraOnClick = extraProps === null || extraProps === void 0 ? void 0 : extraProps.onClick;
    var handleClick = react_1.useCallback(function (e) {
        e.stopPropagation(); // 防止点击造成 select active 变更
        extraOnClick === null || extraOnClick === void 0 ? void 0 : extraOnClick(e);
    }, [extraOnClick]);
    var searchInput = (react_1.default.createElement("input", tslib_1.__assign({}, extraProps, { ref: searchInputRef, className: utils_1.concat(selectClassName, 'search-input'), value: searchValue, onChange: handleSearchInputChange, onClick: handleClick })));
    return { searchValue: searchValue, setSearchValue: setSearchValue, searchInput: searchInput, focusSearchInput: focusSearchInput };
}
exports.useSearchInput = useSearchInput;
//# sourceMappingURL=Selector.js.map